import { deepCopy, getPicSrc } from "@/utils/utils";

/** 保存校验弹窗：无图或加载失败时的占位图 */
export const BACK_PREVIEW_PLACEHOLDER =
  "data:image/svg+xml," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="160" viewBox="0 0 400 160">' +
      '<rect width="100%" height="100%" fill="#eef1f6"/>' +
      '<rect x="140" y="36" width="120" height="72" rx="6" fill="#dcdfe6" stroke="#c0c4cc" stroke-width="1"/>' +
      '<path d="M155 88 L175 68 L195 82 L215 58 L245 88 Z" fill="#c0c4cc"/>' +
      '<circle cx="172" cy="58" r="8" fill="#c0c4cc"/>' +
      '<text x="200" y="128" text-anchor="middle" fill="#909399" font-size="14" font-family="Microsoft YaHei,sans-serif">图片丢失</text>' +
      "</svg>"
  );

function previewFromBack(comp) {
  if (!comp || !comp.style) {
    return "";
  }
  const info = comp.style.backgroundInfo;
  if (info && typeof info === "object") {
    const p =
      info.file_down_path ||
      info.fileDownPath ||
      info.pictureSrc ||
      info.picture_src;
    if (p) {
      return String(p).trim();
    }
  }
  const src = comp.style.backPicSrc || comp.style.backgroundImage;
  if (!src) {
    return "";
  }
  const str = String(src).trim();
  const fromCss = getPicSrc(str);
  if (fromCss) {
    return fromCss.trim();
  }
  const m = str.match(/\(([^)]+)\)/);
  if (m && m[1]) {
    return m[1].trim();
  }
  return str;
}

/** 供预览 img 使用的绝对地址 */
export function resolveBackPreviewUrl(comp) {
  const raw = previewFromBack(comp);
  if (!raw) {
    return "";
  }
  const s = String(raw).trim();
  if (/^(https?:|data:|\/\/)/i.test(s)) {
    return s;
  }
  if (s.startsWith("/")) {
    const origin =
      typeof window !== "undefined" && window.location
        ? window.location.origin
        : "";
    return origin ? origin + s : s;
  }
  return s;
}

function fileLabel(comp) {
  const info = comp && comp.style && comp.style.backgroundInfo;
  if (!info) {
    return "默认背景";
  }
  return (
    info.file_real_name ||
    info.fileRealName ||
    info.file_name ||
    info.fileName ||
    info.pictureName ||
    "背景图"
  );
}

function isBackComponent(comp) {
  if (!comp) {
    return false;
  }
  return comp.component === "Back" || comp.id === "Back";
}

/** 列出同页所有 Back 组件（含下标），用于选择保留哪一个 */
export function listBackCandidates(pageArr) {
  if (!Array.isArray(pageArr)) {
    return [];
  }
  const out = [];
  pageArr.forEach((comp, index) => {
    if (!isBackComponent(comp)) {
      return;
    }
    out.push({
      index,
      label: fileLabel(comp),
      previewUrl: resolveBackPreviewUrl(comp),
      isCanvasVisible: index === 0,
    });
  });
  return out;
}

export function hasDuplicateBacks(pageArr) {
  return listBackCandidates(pageArr).length > 1;
}

/**
 * 保留 keepIndex 对应的 Back，放到数组首位，删除其余 Back。
 */
export function resolveBackChoice(pageArr, keepIndex) {
  if (!Array.isArray(pageArr) || keepIndex == null) {
    return pageArr;
  }
  const idx = Number(keepIndex);
  if (Number.isNaN(idx) || !pageArr[idx] || !isBackComponent(pageArr[idx])) {
    return pageArr;
  }
  const kept = deepCopy(pageArr[idx]);
  const others = pageArr.filter(
    (c, i) => i !== idx && c && !isBackComponent(c)
  );
  return [kept, ...others];
}

export function defaultKeepBackIndex(pageArr) {
  const list = listBackCandidates(pageArr);
  if (!list.length) {
    return 0;
  }
  const visible = list.find((c) => c.isCanvasVisible);
  return visible ? visible.index : list[0].index;
}
